import { Col, Colors } from '@microfrontends/react-components'
import { DbStar, BgRulingNumber } from './SVG'
import { BaseNumberCss, NumberCss } from './index.css'
import { IRulingNumber } from './const'

interface IProps {
	textHead?: string
	number: number
	dbStar?: boolean
	active?: boolean
}

export const BaseNumber = ({ number, active, textHead, dbStar }: IProps) => {
	return (
		<BaseNumberCss className={active ? 'active' : ''}>
			{!textHead ? null : (
				<div className='text-head'>
					<svg viewBox='0 0 500 500'>
						<path
							id='curve'
							d='M73.2,148.6c4-6.1,65.5-96.8,178.6-95.6c111.3,1.2,170.8,90.3,175.1,97'
							fill='transparent'
						/>
						<text width='500'>
							<textPath
								xlinkHref='#curve'
								startOffset='50%'
								textAnchor='middle'
								fill='#fff'
								fontSize='3.5rem'
							>
								{textHead}
							</textPath>
						</text>
					</svg>
				</div>
			)}
			<svg
				className={`circle ${active ? 'active' : ''}`}
				xmlns='http://www.w3.org/2000/svg'
				width='90'
				height='59'
				viewBox='0 0 137 59'
				fill='none'
			>
				<path
					d='M135.567 5.27423C135.243 4.3843 134.51 3.62102 133.322 3.00428C132.131 2.38584 130.516 1.93329 128.504 1.65819C124.48 1.10812 118.976 1.28124 112.365 2.14407C99.1524 3.86867 81.6311 8.33349 62.9407 15.1362C44.2502 21.939 27.9582 29.7812 16.7281 36.9531C11.1095 40.5413 6.78153 43.9469 4.05286 46.9546C2.68815 48.4589 1.7421 49.8435 1.22729 51.0828C0.713895 52.3186 0.642486 53.375 0.966397 54.2649C1.29031 55.1548 2.02399 55.9181 3.21168 56.5348C4.40265 57.1533 6.01737 57.6058 8.02971 57.8809C12.0533 58.431 17.5578 58.2579 24.1683 57.3951C37.3811 55.6705 54.9024 51.2056 73.5928 44.4029C92.2833 37.6001 108.575 29.7579 119.805 22.586C125.424 18.9978 129.752 15.5922 132.481 12.5845C133.845 11.0802 134.791 9.69565 135.306 8.45636C135.82 7.22048 135.891 6.16417 135.567 5.27423Z'
					stroke='url(#paint0_linear_14_3047)'
				/>
				<defs>
					<linearGradient
						id='paint0_linear_14_3047'
						x1='73.7639'
						y1='44.8727'
						x2='61.5416'
						y2='13.7661'
						gradientUnits='userSpaceOnUse'
					>
						<stop stopColor='white' />
						<stop offset='1' stopColor='white' stopOpacity='0' />
					</linearGradient>
				</defs>
			</svg>

			{dbStar ? <DbStar className='db-star' /> : null}
			<span>{number}</span>
		</BaseNumberCss>
	)
}
export const Number = ({ svg, number }: IRulingNumber) => {
	return (
		<NumberCss>
			<BgRulingNumber svg={svg} number={number} />
			<span>{number}</span>
		</NumberCss>
	)
}
